var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Utility Icons / C / chart"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5207 5.90002L5.78992 8.5077C5.46684 8.66923 5.09761 8.43847 5.09761 8.09231V2.43851C5.09761 2.20774 4.86684 2.02313 4.65914 2.09236C2.35143 2.73851 0.689879 4.97695 0.966805 7.53847C1.22065 9.86922 3.0899 11.7615 5.44376 12.0154C8.51302 12.3384 11.0977 9.96153 11.0977 6.96155C11.0977 6.68463 11.0746 6.40771 11.0284 6.13079C10.9823 5.90002 10.7284 5.78464 10.5207 5.90002ZM6.41287 6.96148L10.9591 4.53842C11.236 4.39996 11.3283 4.03073 11.1437 3.77689C10.1052 2.34613 8.48981 1.30767 6.64364 1.00768C6.32057 0.938446 6.02056 1.19229 6.02056 1.51536V6.73071C6.02056 6.9384 6.22826 7.05378 6.41287 6.96148Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/dashboardIcon.dada15529a17b15f23f19838c1ea7c49.svg";
export { ForwardRef as ReactComponent };